module.exports = __webpack_public_path__ + "static/media/KITHIDRONEUMATICOSYDjsp.b10361e8.pdf";